export default __webpack_public_path__ + "media/images/temporary/mud-run-1-e18f15c033cc7c7080f9ea7587e561bf.jpg";